export const activateTnsCounter = (options) => {
    return new Promise((resolve) => {
        if (process.env.NODE_ENV === 'development') {
            resolve();
            return;
        }
        /* eslint-disable */
        // prettier-ignore
        (function (win, doc, cb) {
            // @ts-ignore
            (win[cb] = win[cb] || []).push(function () {
                try {
                    const counterOptions = Array.isArray(options) ? options : [options];
                    counterOptions.forEach(({ account, tmsec }) => {
                        // @ts-ignore
                        win[`tnsCounter${account}_${tmsec}`] = new Mediascope.TnsCounter({
                            account,
                            tmsec
                        });
                    });
                }
                catch (e) { }
            });
            var tnsscript = doc.createElement('script');
            tnsscript.type = 'text/javascript';
            tnsscript.async = true;
            tnsscript.src = ('https:' == doc.location.protocol ? 'https:' : 'http:') +
                '//www.tns-counter.ru/tcounter.js';
            tnsscript.onload = () => resolve();
            tnsscript.onerror = () => resolve();
            var s = doc.getElementsByTagName('script')[0];
            // @ts-ignore
            s.parentNode.insertBefore(tnsscript, s);
        })(window, window.document, 'tnscounter_callback');
        /* eslint-enable */
    });
};
